/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formtype_Options_Recruitment1Inputs */

const ja_contact_formtype_options_recruitment1 = /** @type {(inputs: Contact_Formtype_Options_Recruitment1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`求人に応募したい`)
};

const en_contact_formtype_options_recruitment1 = /** @type {(inputs: Contact_Formtype_Options_Recruitment1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recruitment`)
};

/**
* | output |
* | --- |
* | "Recruitment" |
*
* @param {Contact_Formtype_Options_Recruitment1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formtype_options_recruitment1 = /** @type {((inputs?: Contact_Formtype_Options_Recruitment1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formtype_Options_Recruitment1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formtype_options_recruitment1(inputs)
	return en_contact_formtype_options_recruitment1(inputs)
});
export { contact_formtype_options_recruitment1 as "contact_formType_options_recruitment" }